import { AnimatePresence, motion } from 'framer-motion';
import { LoadingAnimation } from '../Animations';

export interface LoaderProps {
  show?: boolean;
  animationEnabled?: boolean;
}

export const Loader = ({ show, animationEnabled = true }: LoaderProps) => {
  return (
    <AnimatePresence initial={animationEnabled}>
      {show && (
        <motion.div
          initial={{ zIndex: 1001, position: 'static' }}
          animate={{
            zIndex: 1001,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          }}
          exit={{ zIndex: 0, position: 'static' }}
        >
          <div className="bg-white z-100 absolute inset-0 flex justify-center items-center">
            <LoadingAnimation animationEnabled={animationEnabled} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
